import React from 'react'
import { dark_close, delete_icon } from '../../assets/images'

const ManageEmployeeModel = ({ visible = '', icon , title , description ,onCancel = () => {} , handler = () => {} }) => {
  return (
         <div
          className={`fixed z-20 inset-0 overflow-y-auto ${visible ? '' : 'hidden'}`}
          aria-labelledby='modal-title'  
          aria-modal='true'
        >
          <div className='flex items-end justify-center  text-center sm:block sm:p-0'>
            <div
              className='fixed inset-0 bg-gray-900 bg-opacity-25 transition-opacity'
              aria-hidden='true'
              onClick={onCancel}
            >
            </div>
            <span className='sm:inline-block sm:align-middle sm:h-screen' aria-hidden='true'>
              &#8203;
            </span>  
            <div className="inline-block  align-bottom bg-white text-left overflow-hidden shadow-xl transform transition-75 sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full"
            style={{zIndex : 1000, borderRadius : '10px'}}
            >
            <div className="bg-white px-4 pb-4 sm:p-8 sm:pb-0">
              <div className='flex flex-row-reverse '>
                <img src={dark_close} alt='closeIcon' className='cursor-pointer' onClick={onCancel} />
              </div>
              <div className=" sm:flex sm:items-start">
                <div className="mx-auto  flex-shrink-0 flex items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-12 sm:w-12">
                  <img  src={icon || delete_icon} className='h-12 w-12' />
                </div>
                <div className="text-center sm:mt-0 sm:ml-4 sm:mr-8 sm:text-left">
                  <h3 className='text-xl leading-6 font-bold  text-gray-700 ' id='modal-title'>
                      {title}
                  </h3>
                  <p className='text-base font-normal text-gray-600 mt-2 mb-7' style={{width : '550px'}}>
                    {description}
                  </p>   
                </div>
              </div>
            </div>
              <div className="bg-gray-100 mt-3 h-20 px-4 border  py-4 pb-5 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className="text-blue-600 text-base bg-white font-semibold rounded-md border-2 px-6 py-2 w-18.25 h-11"
                  onClick={handler}
                  >
                    Yes
                  </button>
                <button
                  type="button"
                  onClick={onCancel}
                  className="text-blue-600 text-base bg-white font-semibold rounded-md border-2 px-6 py-2 w-18.25 h-11 mr-3"                
                  >
                    No
                </button>
              </div>
            </div>
          </div>
        </div>   
      )
}

export default ManageEmployeeModel